<template>
  <div id="theme" class="pt-30 pb-30 w-full border-b border-hover">
    <p class="text-25 font-bold">Theme</p>
    <div class="flex flex-wrap mt-15">
      <div class="md:mr-10">
        <p class="font-bold ml-5">Light</p>
        <div class="flex flex-wrap -mx-20 md:-mx-10">
          <!-- Magenta -->
          <RadioModule :value="settings.theme" :has-border="true"
                       class="mt-10 mx-10 flex flex-col justify-between"
                       input-value="Magenta" group="test"
                       :label-class="['text-14 mt-20 ml-15 mb-2', {'font-bold': settings.theme === 'Magenta'}]"
                       @input="updateTheme('Magenta')"
          >
            <div class="cursor-pointer">
              <div class="h-115 w-140">
                <img class="w-full" :src="require(`@/assets/images/settings/Magenta.svg`)" alt="mode">
              </div>
            </div>
            <template #label>
              <div class="relative ml-8">
                Magenta
              </div>
            </template>
          </RadioModule>

          <!-- original -->
          <div class="mt-10 mx-10">
            <div class="h-115 w-140 cursor-pointer" @click="updateTheme(hueTheme)">
              <img class="w-full" :src="require(`@/assets/images/settings/${hueTheme}.svg`)" alt="mode">
            </div>
            <div class="flex justify-center -mx-2 mt-10">
              <div class="theme" :class="{ 'border border-orange-main': settings.theme === 'Light Orange' }" @click="updateTheme('Light Orange')">
                <div class="bg-orange-main theme-item">
                  <i v-if="settings.theme === 'Light Orange'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-blue-main': settings.theme === 'Light Blue' }" @click="updateTheme('Light Blue')">
                <div class="bg-blue-main theme-item">
                  <i v-if="settings.theme === 'Light Blue'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-pink-main': settings.theme === 'Light Pink' }" @click="updateTheme('Light Pink')">
                <div class="bg-pink-main theme-item">
                  <i v-if="settings.theme === 'Light Pink'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-green-new': settings.theme === 'Light Green' }" @click="updateTheme('Light Green')">
                <div class="bg-green-new theme-item">
                  <i v-if="settings.theme === 'Light Green'" class="icon-check text-10 text-white" />
                </div>
              </div>
            </div>
            <label class="flex cursor-pointer items-center text-14 mt-10 ml-15 mb-2" :class="{'font-bold': isHueTheme}" @click="updateTheme(hueTheme)">
              <div v-if="isHueTheme" class="h-16 w-16 rounded-full flex justify-center items-center border border-grey-700">
                <div class="w-12 h-12 rounded-full bg-main-color" />
              </div>
              <div v-else class="h-16 w-16 rounded-full border border-grey-700" />
              <span class="ml-8">Hue</span>
            </label>
          </div>

          <!-- poseidon -->
          <!-- <RadioModule :value="settings.theme" :has-border="true"
                       class="mt-10 mx-10 flex flex-col justify-between"
                       input-value="Poseidon" group="test"
                       :label-class="['text-14 mt-20 ml-15 mb-2', {'font-bold': settings.theme === 'Poseidon'}]"
                       @input="v => !isFreePlan && updateTheme(v)"
          >
            <div class="cursor-pointer">
              <div class="h-115 w-140" :class="{ 'opacity-50': isFreePlan }">
                <img class="w-full" :src="require(`@/assets/images/settings/Poseidon.svg`)" alt="mode">
              </div>
            </div>
            <template #label>
              <ProOnly class="ml-8">
                <span>Poseidon</span>
              </ProOnly>
            </template>
          </RadioModule> -->
        </div>
      </div>

      <div class="md:ml-10 mt-20" :class="isHeaderDesign ? 'mt-30': 'md:mt-0'">
        <p class="font-bold ml-5">Dark</p>
        <div class="flex flex-wrap -mx-20 md:-mx-10">
          <!-- D A R K  T H E M E -->
          <div class="mt-10 mx-10">
            <div class="h-115 w-140 cursor-pointer" @click="updateTheme(twilightTheme)">
              <img class="w-full" :src="require(`@/assets/images/settings/${twilightTheme}.svg`)" alt="mode">
            </div>
            <div class="flex justify-center -mx-2 mt-10">
              <div class="theme" :class="{ 'border border-grey-main': settings.theme === 'Dark Purple' }" @click="updateTheme('Dark Purple')">
                <div class="bg-purple-dark theme-item">
                  <i v-if="settings.theme === 'Dark Purple'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-grey-main': settings.theme === 'Dark Orange' }" @click="updateTheme('Dark Orange')">
                <div class="bg-orange-main theme-item">
                  <i v-if="settings.theme === 'Dark Orange'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-grey-main': settings.theme === 'Dark Blue' }" @click="updateTheme('Dark Blue')">
                <div class="bg-dark-blue theme-item">
                  <i v-if="settings.theme === 'Dark Blue'" class="icon-check text-10 text-white" />
                </div>
              </div>
              <div class="theme" :class="{ 'border border-grey-main': settings.theme === 'Dark Green' }" @click="updateTheme('Dark Green')">
                <div class="bg-green-dark theme-item">
                  <i v-if="settings.theme === 'Dark Green'" class="icon-check text-10 text-white" />
                </div>
              </div>
            </div>
            <label class="flex cursor-pointer items-center text-14 mt-10 ml-30 mb-2" :class="{'font-bold': isTwilightkTheme}" @click="updateTheme(twilightTheme)">
              <div v-if="isTwilightkTheme" class="h-16 w-16 rounded-full flex justify-center items-center border border-grey-700">
                <div class="w-12 h-12 rounded-full bg-main-color" />
              </div>
              <div v-else class="h-16 w-16 rounded-full border border-grey-700" />
              <span class="ml-8">Twilight</span>
            </label>
          </div>

          <!-- dracula -->
          <RadioModule :value="settings.theme" :has-border="true"
                       class="mt-10 mx-10 flex flex-col justify-between"
                       input-value="Dracula" group="test"
                       :label-class="['text-14 mt-20 ml-15 mb-2', {'font-bold': settings.theme === 'Dracula'}]"
                       @input="v => !isFreePlan && updateTheme(v)"
          >
            <div class="cursor-pointer">
              <div class="h-115 w-140" :class="{ 'opacity-50': isFreePlan }">
                <img class="w-full" :src="require(`@/assets/images/settings/Dracula.svg`)" alt="mode">
              </div>
            </div>
            <template #label>
              <ProOnly class="ml-8">
                <span>Dracula</span>
              </ProOnly>
            </template>
          </RadioModule>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioModule from '@/components/shared/form-controls/RadioModule'
import ProOnly from '@/components/shared/ProOnly'

import { mapState, mapMutations, mapGetters } from 'vuex'
import { settingsService } from '@/services'

import { updatePreviousThemesLocalStorage, dispatchChangingDesign } from '@/core/helper-functions'

export default {
  components: { RadioModule, ProOnly },

  props: {
    themes: {
      type: Array
    },
    isHeaderDesign: Boolean
  },

  data () {
    return {
      hueTheme: 'Light Orange',
      twilightTheme: 'Dark Purple'
    }
  },

  computed: {
    ...mapState({
      settings: state => state.settings.settings,
      user: state => state.profile.user
    }),

    ...mapGetters(['isDarkMode', 'isFreePlan', 'isMobile']),

    isHueTheme () {
      return this.settings?.theme?.includes('Light')
    },

    isTwilightkTheme () {
      return this.settings?.theme?.includes('Dark')
    }
  },

  created () {
    if (this.isHueTheme) {
      this.hueTheme = this.settings.theme
    }

    if (this.isTwilightkTheme) {
      this.twilightTheme = this.settings.theme
    }
  },

  methods: {
    ...mapMutations(['updateSettings', 'updatePreviousTheme', 'updatePreviousDarkTheme']),

    updateTheme (value) {
      // set prev theme
      if ((!value.includes('Dark')) && (value !== 'Dracula')) {
        this.updatePreviousTheme(value)
        updatePreviousThemesLocalStorage(this.user, 'light', value)
      } else {
        this.updatePreviousDarkTheme(value)
        updatePreviousThemesLocalStorage(this.user, 'dark', value)
      }

      // save original theme
      if (value.includes('Light')) {
        this.hueTheme = value
      } else if (value.includes('Dark')) {
        // save dark theme
        this.twilightTheme = value
      }

      const design = { ...this.settings }
      design.theme = value

      this.updateSettings({ id: this.settings.id, ...design })
      settingsService.update(design)

      dispatchChangingDesign(design)
    },

    upgradeToPro () {
      if (this.user) {
        window.open(`https://helloivy.co/upgrade?userId=${this.user.id}`, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.theme {
  @apply w-16 h-16 cursor-pointer rounded-full mx-2 flex items-center justify-center;

  &-item {
    @apply w-12 h-12  rounded-full flex justify-center items-center;
  }
}
</style>
